<template>
  <v-container tag="section" class="px-10 pb-10">
    <v-overlay :value="isLoadingActions">
      <v-progress-circular color="#FBB040" indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-tabs v-model="tabs" hide-slider>
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-1" active-class="bg-primary white--text rounded-lg">
        <v-icon>mdi-account</v-icon>
        <span class="ml-4">Thông tin tài khoản</span>
      </v-tab>

      <v-tab href="#tab-2" active-class="bg-primary white--text rounded-lg">
        <v-icon>mdi-security</v-icon>
        <span class="ml-4">Bảo mật</span>
      </v-tab>
    </v-tabs>
    <v-tabs-items v-model="tabs">
      <v-tab-item value="tab-1">
        <v-skeleton-loader
          :loading="isLoading"
          type="list-item-three-line, list-item-three-line, table"
          max-width="50%"
        >
          <template>
            <v-form ref="form" v-model="valid" class="mt-8" lazy-validation>
              <BasicInformation
                v-model="basicInformation"
                :isUpdateMode="true"
                @phone-changed="phoneChanged"
                @image-uploading="imageUploading"
              />
              <AdditionalInformation v-model="additionalInformation" />
              <v-row class="mt-4">
                <v-col cols="12" sm="6">
                  <v-btn
                    large
                    color="#FBB040"
                    class="text-white"
                    button
                    dark
                    @click="onUpdate"
                  >
                    <v-icon right dark class="mr-2"> mdi-folder-plus</v-icon>
                    Cập nhật
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </template>
        </v-skeleton-loader>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-form ref="formPassword" v-model="validPassword" lazy-validation>
          <div class="mt-8 ml-4">
            <p class="text-xl font-medium">Đổi mật khẩu</p>
            <v-row class="mt-0">
              <v-col cols="12" sm="4">
                <v-text-field
                  v-model="oldPassword"
                  :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                  outlined
                  placeholder="Mật khẩu cũ"
                  :rules="[rules.required]"
                  :type="showPass ? 'text' : 'password'"
                  @click:append="showPass = !showPass"
                  label="Mật khẩu cũ*"
                />
                <v-text-field
                  v-model="newPassword"
                  :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                  outlined
                  placeholder="Mật khẩu cũ"
                  :rules="[rules.required]"
                  :type="showPass ? 'text' : 'password'"
                  @click:append="showPass = !showPass"
                  label="Mật khẩu mới*"
                />
              </v-col>
            </v-row>
            <v-row class="mt-4">
              <v-col cols="12" sm="6">
                <v-btn
                  x-large
                  color="#FBB040"
                  class="text-white"
                  button
                  dark
                  @click="onUpdatePassword"
                >
                  <v-icon right dark class="mr-2"> mdi-folder-plus </v-icon>
                  Cập nhật
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import BasicInformation from "~/components/organisms/profile/BasicInformation";
import AdditionalInformation from "~/components/organisms/profile/AdditionalInformation";
import { EMPTY } from "~/utils/constants";
import { required, email } from "~/utils/validation";
import { $toasted } from "@/plugins/vue-toast";
import { mapState } from "vuex";

export default {
  name: "PatientDetail",
  components: { BasicInformation, AdditionalInformation },
  data() {
    return {
      showPass: false,
      showPassNew: false,
      tabs: null,
      rules: {
        required,
        email,
      },
      basicInformation: {
        id: null,
        name: EMPTY,
        email: null,
        phone: EMPTY,
        roleName: EMPTY,
        address: EMPTY,
        dateOfBirth: EMPTY,
        gender: null,
        profilePublicId: null,
        profileURL: null,
      },
      additionalInformation: {
        facebookUrl: null,
        zaloUrl: null,
        description: null,
      },
      valid: true,
      validPassword: true,
      isLoadingActions: false,
      isLoading: false,
      oldPassword: null,
      newPassword: null,
      repeatNewPassword: null,
    };
  },
  computed: {
    ...mapState({
      userProfile: (state) => state.userProfile,
    }),
  },
  async created() {
    try {
      this.isLoading = true;
      const data = await this.$services.commonService.getUserProfile();
      if (
        data &&
        Object.keys(data).length !== 0 &&
        Object.getPrototypeOf(data) === Object.prototype
      ) {
        this.assignObject(data, this.basicInformation);
        this.assignObject(data, this.additionalInformation);
      }
    } catch {
    } finally {
      this.isLoading = false;
    }
  },
  methods: {
    assignObject(resource, destination) {
      Object.keys(resource).forEach((key) => {
        if (destination[key] !== undefined) {
          destination[key] = resource[key];
        }
      });
    },
    async imageUploading(isLoadingActions) {
      this.isLoadingActions = isLoadingActions;
    },
    async phoneChanged(newPhone) {
      this.newPhoneValue = newPhone;
      if (/^-?\d+$/.test(this.newPhoneValue) && this.newPhoneValue.length == 10) {
        try {
          this.isLoadingActions = true;
          const data = await this.$services.patientService.getPatientDetailByPhone(
            this.newPhoneValue
          );
          if (data) {
            $toasted.error("Số điện thoại đã thuộc về một bệnh nhân khác").goAway(2000);
          }
        } catch (err) {
          $toasted.error("Có lỗi xảy ra. Vui lòng liên hệ người quản trị").goAway(2000);
        } finally {
          this.isLoadingActions = false;
        }
      }
    },
    async onUpdate() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.isLoadingActions = true;
        try {
          await this.$services.commonService.updateUserProfile({
            ...this.basicInformation,
            ...this.additionalInformation,
            isActive: this.isActive,
            isDeleted: this.isDeleted,
          });
        } catch (err) {
          console.log(err);
        } finally {
          this.isLoadingActions = false;
        }
      }
    },
    async onUpdatePassword() {
      await this.$refs.formPassword.validate();
      if (this.validPassword) {
        this.isLoadingActions = true;
        try {
          await this.$services.commonService.updateUserPassword({
            oldPassword: this.oldPassword,
            password: this.newPassword,
          });
          this.oldPassword = null;
          this.newPassword = null;
        } catch (err) {
          console.log(err);
        } finally {
          this.isLoadingActions = false;
        }
      }
    },
  },
};
</script>
